import { GC_TIME_LONG, QueryKey, STALE_TIME_LONG } from '@/constants/shared';
import { makeRequest } from '@/network/api';
import { Badge } from '@/types';
import { useQuery } from '@tanstack/react-query';

export const useBadges = (profileAddress?: string) => {
  const {
    data: badges,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [QueryKey.Badges, profileAddress],
    queryFn: async (): Promise<Badge[]> => {
      const response = await makeRequest(`badges?walletAddress=${profileAddress}`);
      const responseJson = await response.json();
      return responseJson.data?.badges;
    },
    refetchOnMount: true,
    staleTime: STALE_TIME_LONG,
    gcTime: GC_TIME_LONG,
  });
  return {
    badges,
    isLoadingBadges: isLoading,
    isErrorBadges: isError,
  };
};
